import * as React from 'react';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const DisabledDatePicker = (props) => {
  const { holidays } = props;
  const holidaysDates = [];
  Array.isArray(holidays) &&
    holidays.forEach((yearData) => {
      yearData.data.forEach((holiday) => {
        holidaysDates.push(holiday.date);
      });
    });

  const currentYear = new Date().getFullYear();
  const nextYear = currentYear + 1;
  const shouldDisableDate = (day) => {
    const year = day.toDate().getFullYear();
    const formattedDate = day.format('YYYY-MM-DD');
    if (holidaysDates.includes(formattedDate)) return true;
    return (
      (year !== currentYear && year !== nextYear) ||
      day.day() === 0 ||
      day.day() === 6
    );
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label="Date"
        value={props.value}
        onChange={(newValue) => {
          props.onDatePicketInputChange(newValue);
        }}
        renderInput={(params) => <TextField {...params} error={props.error} />}
        shouldDisableDate={shouldDisableDate}
      />
    </LocalizationProvider>
  );
};

export default DisabledDatePicker;
